import { useQuery } from '@tanstack/react-query';
import { Product } from 'types/order';
import { client } from './api-client';

const useListProducts = () =>
  useQuery(['products'], () => client<Product[]>(`/megr/termekek`, { method: 'get' }), {
    initialData: []
  });

export { useListProducts };
